import React from "react";
import { Link } from "react-router-dom";
import Footer from "../../Footer";

const D336 = () => {
  return (
    <div className="container" style={{ maxWidth: "80%" }}>
      <h1 className="text-center mt-4">
        WGU Course Buffet: All You Can Read 🍽️📖
      </h1>
      <Link type="button" class="btn btn-secondary" to="/courses">
        <i class="fa-solid fa-circle-arrow-left"></i> Buffet Menu
      </Link>

      <h2 className="text-center">You're viewing D336 - Business of IT - Applications</h2>

      <div className="card my-4">
        <h4 className="text-center mt-4">
          WGU Course Material : <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
        </h4>
        <h4 className="text-center my-2">Total Time Taken: 6.78 hrs</h4>
        <hr />
        <div className="card-body">
          <p>
            Absolutely HATED this course. The Jason Dion Udemy course is really
            good, especially focusing on the service management part. But the
            problem is, most of this course is just memorizing stuff, and I hate
            doing that. There’s not much to "understand," it's just about
            byhearting information.
          </p>
          <p>
            The worst part was after doing a million practice tests (ask your
            instructor for those, they will send you a bunch), the actual test
            was WAY more difficult. I couldn’t even understand half of the
            questions and just winged it. I was sure I failed, but somehow
            passed by 1 point! 😂
          </p>
          <p>Here’s the material I used to study:
            <ul>
                <li><a href="https://itsm.tools/34-itil-4-management-practices/#:~:text=Relationship%20management%20%E2%80%93%20%E2%80%9CThe%20purpose%20of,at%20strategic%20and%20tactical%20levels.">ITIL 4 Management Practices</a></li>
                <li><a href="https://purplegriffon.com/blog/itil4-foundation-the-definitive#:~:text=Customer%20%2D%20is%20defined%20as%20a,the%20outcomes%20of%20service%20consumption.%E2%80%9D">Purple Griffon ITIL 4 Foundation</a></li>
                <li><a href="https://pdfcoffee.com/itil-4-foundation-cram-card-pdf-free.html">ITIL 4 Foundation Cram Card PDF</a></li>
                <li><a href="https://purplegriffon.com/courses/itil/itil-v4-foundation-course">Purple Griffon ITIL 4 Foundation Course</a></li>
                <li><a href="https://www.scribd.com/document/603986014/Itil-4-Foundation-Cheat-Sheet">Scribd ITIL 4 Foundation Cheat Sheet</a></li>
                <li><a href="https://quizlet.com/805505980/itil-4-foundation-practice-exam-4-flash-cards/">Quizlet ITIL 4 Foundation Practice Exam 4</a></li>
                <li><a href="https://blog.ifs.com/2022/07/itil-4-service-value-chain/">ITIL 4 Service Value Chain</a></li>
            </ul>
          </p>
          <p>Also, make sure you download these two cheat sheets:
            <ul>
                <li><a href="/ITIL-4-Foundation-Cram-Card (1).pdf" target="ITIL-4-Foundation-Cram-Card (1).pdf">Cheat Sheet 1</a></li>
                <li><a href="/ITIL+4+Study+Guide.pdf" target="ITIL+4+Study+Guide.pdf">Cheat Sheet 2</a></li>
            </ul>
          </p>
        </div>
      </div>
      <Footer/>
    </div>
  );
};
export default D336;
